import type { FC } from "react";

import { Modal } from "@aviary";
import { Routes, Route } from "@shared/react-router-dom";
import { Size } from "@shared/types/sizes";
import { wildcardPath } from "@shared/utils";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import { PatientRxBackground } from "@unauthenticated/signupSignin/components";
import type { PatientAttributes } from "@unauthenticated/signupSignin/data/types";

import { RxSignInModalMain } from "./PatientRxSignInModal";
import { RxSignInForgotPassword } from "./PatientRxSignInModal/RxSignInForgotPassword";

interface Props {
  patientAttributes: PatientAttributes;
  additionalAttributes?: any;
  ssoErrors?: string;
}

const PatientRxSignInPage: FC<Props> = ({ patientAttributes, additionalAttributes, ssoErrors }) => {
  return (
    <PatientRxBackground>
      <Modal isOpen hideClose isSize={Size.MEDIUM}>
        <Routes>
          <Route
            path={authRoutes.rx_sign_in_forgot_password()}
            element={<RxSignInForgotPassword />}
          />
          <Route
            path={wildcardPath(authRoutes.rx_sign_in)}
            element={
              <RxSignInModalMain
                patientAttributes={patientAttributes}
                additionalAttributes={additionalAttributes}
                ssoErrors={ssoErrors}
              />
            }
          />
        </Routes>
      </Modal>
    </PatientRxBackground>
  );
};

export { PatientRxSignInPage };
